<div class="popover-container">
    <div class="dimmer"></div>
    <div [ngClass]=" isFull? 'full-view' : customStyle ">

      <app-button
        (clickCallback)="onCloseClick()"
        class="popover-close"
        prefixIconSrc="assets/images/cancel_24.svg"
        type="icon"
      ></app-button>
      <div class="view-icon" (click)="isFull = !isFull">
        <img src="../../../../assets/images/ful-view.svg" alt="">
      </div>

      <div class="popover-content">
        <ng-content select="[popover-content]"></ng-content>
      </div>
    </div>
    
  </div>
